import { Navigate, Route } from "react-router-dom";
import { ERoute } from "./RoutesEnums";
import AboutUs from "../pages/aboutus/AboutUs";
import PrivacyPolicy from "../pages/privacypolicy/PrivacyPolicy";
import { IDeviceStateControllerReturn } from "../../../../commonreact/main/services/devicestate/DeviceStateController";
import Service from "../pages/service/Service";
import AndroidApp from "../pages/androidapp/AndroidApp";
import Website from "../pages/website/Website";
import { IEditBaseControllerReturn } from "../controllers/EditBaseController";
import { IModalOkCancelControllerReturn } from "../../../../commonreact/main/components/modals/modalok/ModalOKCancelController";
import HoneyPotRedirect from "../pages/redirect/HoneyPotRedirect";
import { IModalVideoControllerReturn } from "../../../../commonreact/main/components/modals/modalvideo/ModalVideoController";

interface IRoute {
  path: string;
  element: JSX.Element | undefined;
  exact: boolean;
}

interface IProps {
  dsc: IDeviceStateControllerReturn;
  ebc: IEditBaseControllerReturn;
  mokc: IModalOkCancelControllerReturn;
  mvc: IModalVideoControllerReturn;
}

export default class UserRoutesStore {

  private static routes: IRoute[] = [];
  public static removeRoute(path: string) {
    this.routes = this.routes.filter(route => route.path !== path);
  }
  public static getRoute(path: string): IRoute | null {
    try { return this.routes.find((it) => it?.path == path)!! } catch (e) { return null }
  }

  public static getPublicRoutes(): JSX.Element {
    return (
      <>
        {this.getRoute(ERoute.AboutUs.valueOf())?.element}
        {this.getRoute(ERoute.Service.valueOf())?.element}
        {this.getRoute(ERoute.PrivacyPolicy.valueOf())?.element}
        {this.getRoute(ERoute.Website.valueOf())?.element}
        {this.getRoute(ERoute.Home.valueOf())?.element}
      </>)
  }


  public static getDefaultRoute(): JSX.Element | undefined {
    try {
      return this.getRoute(ERoute.Default.valueOf())?.element
    } catch (e) {
      return undefined
    }
  }

  public static getHoneyPotRoute(): JSX.Element | undefined {
    try {
      return<> {this.getRoute(ERoute.RedirectToExternalThankYou.valueOf())?.element} </>
    } catch (e) {
      return undefined
    }
  }



  //#region newInit
  constructor(private props: IProps) {
    this.setRoutes();
  }

  private setRoutes() {
    UserRoutesStore.routes = [
      //#region publicRoutes
      { path: ERoute.Default.valueOf(), element: <Route path={ERoute.Default.valueOf()} element={<Navigate replace to={ERoute.Home.valueOf()} />} />, exact: true },
      { path: ERoute.Service.valueOf(), element: <Route path={ERoute.Service.valueOf()} element={<Service dsc={this.props.dsc} ebc={this.props.ebc} mokc={this.props.mokc} />} />, exact: true },
      { path: ERoute.AboutUs.valueOf(), element: <Route path={ERoute.AboutUs.valueOf()} element={<AboutUs dsc={this.props.dsc} />} />, exact: true },
      { path: ERoute.PrivacyPolicy.valueOf(), element: <Route path={ERoute.PrivacyPolicy.valueOf()} element={<PrivacyPolicy dsc={this.props.dsc} />} />, exact: true },
      { path: ERoute.Website.valueOf(), element: <Route path={ERoute.Website.valueOf()} element={<Website dsc={this.props.dsc} mvc={this.props.mvc} />} />, exact: true },
      { path: ERoute.Home.valueOf(), element: <Route path={ERoute.Home.valueOf()} element={<AndroidApp dsc={this.props.dsc} mvc={this.props.mvc} />} />, exact: true },

      { path: ERoute.RedirectToExternalThankYou.valueOf(), element: <Route path={ERoute.RedirectToExternalThankYou.valueOf()} element={<HoneyPotRedirect dsc={this.props.dsc} />} />, exact: true }

    ]
  }
  //#endregion
}